var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77.9 115.7",
    style: {
      enableBackground: "new 0 0 77.9 115.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,43.6c0-10.3,8.9-19.1,19.3-19.1c10.6-0.1,19.5,8.6,19.5,19.1c0,11.1-8.2,19.5-19.3,19.5 C27.9,63.2,19.4,54.8,19.5,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,76.1c8.9,7.7,12.4,17.9,12.9,29.4c0.1,3,0,6,0,9.3H1.1c-2-17,2.5-33.3,17.6-42.5C32.9,63.7,51.9,65.3,64.3,76.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.4,1.2l2.1,6.6c0,0.1,0.2,0.2,0.3,0.2h6.9c0.3,0,0.4,0.4,0.2,0.5l-5.6,4.1c-0.1,0.1-0.1,0.2-0.1,0.3l2.1,6.6 c0.1,0.3-0.2,0.5-0.5,0.3l-5.6-4.1c-0.1-0.1-0.2-0.1-0.3,0l-5.6,4.1c-0.2,0.2-0.5-0.1-0.5-0.3l2.1-6.6c0-0.1,0-0.3-0.1-0.3 l-5.6-4.1c-0.2-0.2-0.1-0.5,0.2-0.5h6.9c0.1,0,0.2-0.1,0.3-0.2l2.1-6.6C37.9,0.9,38.3,0.9,38.4,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3,13.1l1.4,4.4c0,0.1,0.2,0.2,0.3,0.2h4.6c0.3,0,0.4,0.4,0.2,0.5l-3.7,2.7c-0.1,0.1-0.1,0.2-0.1,0.3l1.4,4.4 c0.1,0.3-0.2,0.5-0.5,0.3l-3.7-2.7c-0.1-0.1-0.2-0.1-0.3,0l-3.7,2.7c-0.2,0.2-0.5-0.1-0.5-0.3l1.4-4.4c0-0.1,0-0.3-0.1-0.3 l-3.7-2.7c-0.2-0.2-0.1-0.5,0.2-0.5H55c0.1,0,0.2-0.1,0.3-0.2l1.4-4.4C56.8,12.8,57.2,12.8,57.3,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,13.1l1.4,4.4c0,0.1,0.2,0.2,0.3,0.2h4.6c0.3,0,0.4,0.4,0.2,0.5l-3.7,2.7c-0.1,0.1-0.1,0.2-0.1,0.3l1.4,4.4 c0.1,0.3-0.2,0.5-0.5,0.3l-3.7-2.7c-0.1-0.1-0.2-0.1-0.3,0l-3.7,2.7c-0.2,0.2-0.5-0.1-0.5-0.3l1.4-4.4c0-0.1,0-0.3-0.1-0.3 l-3.7-2.7c-0.2-0.2-0.1-0.5,0.2-0.5h4.6c0.1,0,0.2-0.1,0.3-0.2l1.4-4.4C19.3,12.8,19.7,12.8,19.8,13.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleicon2);
export default __webpack_public_path__ + "static/media/role icon2.bea333d41338bd3416e830a38673433e.svg";
export { ForwardRef as ReactComponent };